/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import ReactTable from "react-table";
import InfiniteScroll from "react-infinite-scroll-component";
import PropTypes from "prop-types";
import LoadingIndicator from "../../widgets/LoadingIndicator/LoadingIndicator";
import {Tabs, Pane, Select} from "@pearson-components/elements-sdk/build/dist.elements-sdk";
import moment from "moment";
import {formatUrl} from "../../../_helpers/urlFormat.helper";
import config from "../../../config";
import axiosClient from "../../../_helpers/http.helper";
import { PERMISSIONS } from "../../../constants/APP_CONSTANTS";
import {Button} from "@pearson-components/elements-sdk/build/dist.elements-sdk";

export default class DigitalCollections extends React.Component {
    static propTypes = {
        collections: PropTypes.object.isRequired,
        selectedData: PropTypes.object.isRequired,
        toggleDigitalRow: PropTypes.func.isRequired,
        toggleDigitalAll: PropTypes.func.isRequired,
        updateProductDelivery: PropTypes.func.isRequired,
        updateShareModalData: PropTypes.func.isRequired,
    };

    state = {
        key: 2
    };

    handleSelection = (type, collection) => {
        let deliveryType = "";
        let enableVitalsource = false;
        if(type === "Custom-eText"){
            deliveryType = "CUSTOMETEXT";
        }if (type === "Collections"){
            deliveryType = "COLLECTIONS";
        }else if(type === "Vitalsource"){
            deliveryType = "VITALSOURCE";
            enableVitalsource = true;
        }
        Promise.all([this.updateProductDeliveryType(collection.collectionId, deliveryType), this.addOrRemoveVitalsourceEntry(collection.collectionId, enableVitalsource)]);
    };

    updateProductDeliveryType = async (collectionId, deliveryType) => {
        let url = formatUrl(config.collectionService.baseUrl, config.collectionService.routes.updateDeliveryType, {
            collectionId: collectionId,
            queryParams: {
                productDelivery : deliveryType
            }
        });
        axiosClient.put(url).then(()=>{
            const index = this.props.collections.items.findIndex((bookBuild)=>{
                return bookBuild.collection.collectionId === collectionId;
            });
            const type = deliveryType === "CUSTOMETEXT" ? "custometext" : deliveryType === "COLLECTIONS" ? "collections" :"vitalsource";
            this.props.updateProductDelivery(index,type);
            
        });
    };

    addOrRemoveVitalsourceEntry = async (collectionId, enableVitalsource) => {
        let url = formatUrl(config.contentPublishVitalsourceService.baseUrl, config.contentPublishVitalsourceService.routes.addOrRemoveVitalsourceEntry, {
            collectionId: collectionId,
            queryParams: {
                enableVitalsource : enableVitalsource
            }
        }); 
        axiosClient.post(url);      
    }

    render() {
        const userRolePermissions = this.props.permissions;
        const prodDeliveryTypeDisableStyle = userRolePermissions.includes(PERMISSIONS.view_only_product_delivery_type) ? 'product-delivery-disabled' : 'product-delivery';
        const columns = [
            {
                Header: () => {
                    return (
                        <div className="pe-checkbox" onClick={this.props.toggleDigitalAll}>
                            <input
                                type="checkbox"
                                id="checkboxInput"
                                value="1"
                                checked={this.props.selectAllDigital}
                                onChange={() => {}}
                            />
                            <span>
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    className="pe-icon--check-sm-18"
                                >
                                    <use xlinkHref="#check-sm-18" />
                                </svg>
                            </span>
                        </div>
                    );
                },
                Cell: row => (
                    <div
                        className="pe-checkbox"
                        onClick={() => {
                            this.props.toggleDigitalRow(row.original.collection);
                        }}
                    >
                        <input
                            type="checkbox"
                            id="checkboxInput"
                            checked={
                                !!this.props.selectedData[
                                    row.original.collection.collectionId
                                ]
                            }
                            onChange={() => {}}
                        />
                        <span>
                            <svg
                                aria-hidden="true"
                                focusable="false"
                                className="pe-icon--check-sm-18"
                            >
                                <use xlinkHref="#check-sm-18" />
                            </svg>
                        </span>
                    </div>
                ),
                width: 50,
                accessor: "collection.collectionId"
            },
            {
                Header: "Product Delivery",
                accessor: "productDeliveryType",
                sortable: true,
                Cell: row => {
                    return (<div>
                        <div className={prodDeliveryTypeDisableStyle}>
                            <Select  key={this.state.key} id="select" changeHandler={(e) => {this.handleSelection(e.target.value, row.original.collection);}} 
                                selectedOption={row.original.productDeliveryType === "collections" ? "Collections" : 
                                    row.original.productDeliveryType === "custometext" ? "Custom-eText" :  "Vitalsource"}
                                options={ ["Collections", "Custom-eText","Vitalsource"] }/>
                        </div>
                    </div>);
                },
                width: 170
            },
            {
                Header: "Title",
                accessor: "collection.title",
                sortable: true,
                Cell: row => {
                    return (<div>
                        {
                            row.original.productDeliveryType === "collections" ?
                                <a href={formatUrl(config.legacyAdmin.baseUrl, config.legacyAdmin.routes.digital,{
                                    collectionId: row.original.collection.collectionId,
                                    status: row.original.collection.status
                                })}>{row.original.collection.title}</a> : row.original.productDeliveryType === "custom-eText" ? 
                                    <a href={formatUrl(config.digitalAdmin.baseUrl, row.original.collection.collectionId)}>{row.original.contractedTitle}</a> :
                                    <a href={formatUrl(config.digitalAdmin.baseUrl, row.original.collection.collectionId)}>{row.original.contractedTitle}</a>
                        }
                    </div>);
                }
            },
            {
                Header: "ISBN",
                accessor: "customISBN.isbn",
                sortable: true,
                Cell: row => {
                    return (<div>
                        <div>{row.original.customISBN.isbn}</div>
                        <div>{row.original.customISBN13}</div>
                    </div>);
                }
            },
            {
                Header: "Submitted",
                accessor: "createDate",
                Cell: row => {
                    return (<span>
                        {row.original.createDate ? moment(row.original.createDate)
                            .format("MM/DD/YY") : ""}
                    </span>);
                },
                sortable: true,
            },
            {
                Header: "Adopter",
                accessor: "adopterFirstName",
                sortable: true,
                Cell: row => {
                    return (<div>
                        <div>{row.original.adopterFirstName + " " + row.original.adopterLastName}</div>
                        <div>{row.original.school}</div>
                    </div>);
                }
            },
            {
                Header: "Enroll",
                id:"saleableQty",
                accessor: d =>
                    Number.parseInt(d.saleableQty, 10),
                sortable: true,
                width: 75
            },
            {
                Header: "Price",
                accessor: "collection.priceModel.totalPrice",
                sortable: true,
                width: 75
            },
            {
                Header: "Class Start",
                accessor: "classStart",
                Cell: row => {
                    return (<span>
                        {row.original.classStart ? moment(row.original.classStart)
                            .format("MM/DD/YY") : ""}
                    </span>);
                },
                sortable: true,

            },
            {
                Header: "Details",
                sortable: true,
                accessor: "collection.resourceIds.length",
                Cell: row => {
                    return (<div>
                        <div>{row.original.collection.resourceIds.length === 0 ? 'N/A' : row.original.collection.resourceIds.length + " Resources"}</div>
                    </div>);
                }
            },
            {
                Header: "Market",
                accessor: "collection.geo.code",
                sortable: true,
                width: 75
            },
            {
                Header: "Status",
                accessor: "collection.status",
                sortable: true,
            },
            {
                Header: "Files Sent",
                accessor: "inviteSent",
                Cell: row => {
                    return (
                        row.original.inviteSent ? <div style={{display: "flex", flexDirection: "column"}}>
                            <span>
                                First Invite Sent
                            </span>
                            <span>
                                {moment(row.original.inviteSent).format("MM/DD/YY")}
                            </span>
                        </div> : ""
                    );
                }
            },
            {
                Header: "Share",
                Cell: row => {
                    return (<div>
                        <Button type="submit" btnType="primary" onClick={() => this.props.updateShareModalData(row.original.collection, true)}>Share</Button>
                    </div>);
                }
            }
        ];
        const { hasMore, loadMore, collections } = this.props;
        return (
            <div className="digital-collection-container">
                <h2>Digital Collections</h2>
                <div className="pe-row">
                    <div className="pe-col-12 pt-4">
                        {collections.totalItems > 0 && (
                            <div id="scrollTable" className="infiniteScroll">
                                <InfiniteScroll
                                    dataLength={
                                        collections.items.length
                                    }
                                    next={loadMore}
                                    hasMore={hasMore}
                                    loader={<LoadingIndicator/>}
                                    scrollableTarget="scrollTable"
                                >
                                    <div className="table-wrap">
                                        <ReactTable
                                            className="-highlight"
                                            data={
                                                collections.items
                                            }
                                            showPagination={false}
                                            columns={columns}
                                            defaultPageSize={
                                                collections.totalItems
                                            }
                                            minRows={0}
                                            sortable={false}
                                            pageText=""
                                            noDataText="No batch details found"
                                            onSortedChange={() => {
                                                this.setState({ key: Math.random() });
                                            }}
                                            getTrProps={() => {
                                                return {
                                                    style: {
                                                        textAlign: "center",
                                                    }
                                                };
                                            }}
                                        />
                                    </div>
                                </InfiniteScroll>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/HomePage/DigitalCollections.js